export function isSupportedLanguage(locale: Intl.Locale, supportedLocales: readonly Intl.Locale[]): boolean {
    return supportedLocales.some((supportedLocale) => supportedLocale.language === locale.language);
}
